export default __webpack_public_path__ + "static/media/chai.d3a79b61.png";